import type {PublicMethodUtils} from '@wix/document-services-types'
import type {CustomCSSPublicAPI} from '@wix/document-services-public-types'
import {customCSS} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<CustomCSSPublicAPI> {
    return {
        methods: {
            customCSS: {
                refresh: publicMethodUtils.defineAction(customCSS.refresh)
            }
        }
    }
}
